import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const dateAdjustmentStartDay = (unix: string): Date | null => {
  if (!unix) return null;
  const utcDate = dayjs.utc(Number(unix)).format('M/D/YYYY');
  const adjsutedDate = dayjs(utcDate).local().startOf('day');
  return adjsutedDate.toDate();
};

export const dateAdjustmentEndDay = (unix: string): Date | null => {
  if (!unix) return null;
  const utcDate = dayjs.utc(Number(unix)).format('M/D/YYYY');
  const adjsutedDate = dayjs(utcDate).local().endOf('day');

  return adjsutedDate.toDate();
};

export const getStartOfDayUtc = (date: Date | number | string) => {
  const daysObject = dayjs(date);
  const dateConstruct = `${daysObject.get('year')}-${
    daysObject.get('month') + 1
  }-${daysObject.get('date')}`;
  const utcDate = dayjs.utc(dateConstruct).startOf('day').valueOf().toString();
  return utcDate;
};

export const getEndOfDayUtc = (date: Date | number | string) => {
  const daysObject = dayjs(date);
  const dateConstruct = `${daysObject.get('year')}-${
    daysObject.get('month') + 1
  }-${daysObject.get('date')}`;
  const utcDate = dayjs
    .utc(dateConstruct)
    .endOf('day')
    .set('milliseconds', 0)
    .valueOf()
    .toString();
  return utcDate;
};
